<template>
  <AppMenuNew
    ref="submenu"
    placement="right-start"
    :offset="0"
  >
    <template #trigger="{ openMenu }">
      <AppMenuNewItem
        :icon="icon"
        :label="label"
        :disabled="disabled"
        is-sub-menu
        @mouseenter="
          (event: MouseEvent) => {
            cancelClose()
            openMenu(event)
          }
        "
        @mouseleave="scheduleClose"
      />
    </template>

    <!-- Hover-intent: moving onto the panel cancels the pending close; leaving
         it (or the trigger) closes the submenu after a short grace period, so a
         hover submenu disappears when you move away. -->
    <template #items>
      <div
        @mouseenter="cancelClose"
        @mouseleave="scheduleClose"
      >
        <slot name="items" />
      </div>
    </template>
  </AppMenuNew>
</template>

<script setup lang="ts">
defineProps({
  icon: {
    type: String,
    default: undefined,
  },
  label: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const submenu = ref<{ closeMenu: () => void } | null>(null)

// Grace period lets the pointer travel from the trigger to the adjacent panel
// without the submenu closing underneath it.
const CLOSE_DELAY_MS = 150
let closeTimer: ReturnType<typeof setTimeout> | null = null

function cancelClose() {
  if (closeTimer) {
    clearTimeout(closeTimer)
    closeTimer = null
  }
}

function scheduleClose() {
  cancelClose()
  closeTimer = setTimeout(() => submenu.value?.closeMenu(), CLOSE_DELAY_MS)
}

onUnmounted(cancelClose)
</script>
